import { registerAPIService } from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';

export default class TWSProjectAPIService extends APIServiceBase {
    constructor() {
        super('TWSProject')
    }

    create(data: any) {
        return this.post('create', data)
    }

    edit(data: any) {
        return this.post('edit', data)
    }

    getHistoricalData(id: number) {
        return this.get(`GetHistoricalData?id=${id}`, {});
    }

    getDocumentationModalContent(id: number) {
        return this.get(`GetDocumentationModalContent?projectId=${id}`, {})
    }

    generateDocumentation(data: any) {
        return this.post('GenerateDocument', data, 'blob')
    }

    hide(id: number) {
        return this.post(`Hide?id=${id}`, {})
    }

    delete(id: number) {
        return this.get(`Delete?id=${id}`, {})
    }

    deleteBatch(data: any) {
        return this.post('DeleteBatch', data)
    }

    copy(id: number) {
        return this.get(`Copy?id=${id}`, {})
    }

    copyAndEdit(id: number) {
        return this.get(`CopyAndEdit?id=${id}`, {});
    }

    copyCalculation(data: any) {
        return this.post('CopyCalculation', data)
    }
    
    setProductSerialNumber(data: any) {
        return this.post('SetProductSerialNumber', data)
    }
}

registerAPIService(TWSProjectAPIService)